import React, { useContext, useEffect, useCallback } from "react";
import { PersonaVideoButtons, PersonaVideo } from "../index";
import { PersonaContainerStyle } from "./PersonaContainerStyles";
import { Store } from "../../context/Store";
// import { deviceType } from "react-device-detect";
import { detectDeviceType } from "../../utils/detectDeviceType";

const PersonaContainer: React.FC<{}> = () => {
  const { state, dispatch } = useContext(Store);
  const { tabletLandscape, scene, videoPlaying, persona, mute } = state;

  const onFocus = useCallback(() => {
    if (!mute) {
      scene?.startRecognize();
    }
  }, [mute]);

  // User has switched away from the tab (AKA tab is hidden)
  const onBlur = () => {
    scene?.stopRecognize();
  };
  // We can add a loading while video starts
  // if (!videoPlaying) return <h1>loading...</h1>;
  useEffect(() => {
    window.addEventListener("focus", onFocus);
    window.addEventListener("blur", onBlur);

    // Specify how to clean up after this effect:
    return () => {
      window.removeEventListener("focus", onFocus);
      window.removeEventListener("blur", onBlur);
    };
  }, [mute]);

  return (
    <PersonaContainerStyle
      deviceType={detectDeviceType()}
      isLandscape={tabletLandscape}
    >
      <PersonaVideo
        scene={scene}
        videoPlaying={videoPlaying}
        dispatch={dispatch}
        tabletLandscape={tabletLandscape}
        persona={persona}
      />
      <PersonaVideoButtons />
    </PersonaContainerStyle>
  );
};

export default PersonaContainer;
